import { type EntityMode } from "./create-data-request-state";

export type DataRequestFieldType =
  | "text"
  | "textarea"
  | "richtext"
  | "date"
  | "number"
  | "status-select"
  | "priority-select"
  | "phase-select"
  | "focus-area-select"
  | "user-select"
  | "label-select"
  | "unit-select"
  | "frequency-select"
  | "indicator-values";

export interface DataRequestFieldDefinition {
  key: string;
  labelKey: string;
  fieldType: DataRequestFieldType;
  /** Entity types this field applies to. Undefined or empty means every type. */
  entityTypes?: EntityMode[];
}

const CLIMATE_ACTION_AND_PROJECT: EntityMode[] = ["CLIMATE_ACTION", "PROJECT"];

/** labelKey references keys under "create.fields" in the data-request i18n namespace. */
export const DATA_REQUEST_FIELDS: DataRequestFieldDefinition[] = [
  { key: "title", labelKey: "create.fields.title", fieldType: "text", entityTypes: CLIMATE_ACTION_AND_PROJECT },
  {
    key: "description",
    labelKey: "create.fields.description",
    fieldType: "richtext",
    entityTypes: CLIMATE_ACTION_AND_PROJECT,
  },
  { key: "status", labelKey: "create.fields.status", fieldType: "status-select", entityTypes: CLIMATE_ACTION_AND_PROJECT },
  {
    key: "priority",
    labelKey: "create.fields.priority",
    fieldType: "priority-select",
    entityTypes: CLIMATE_ACTION_AND_PROJECT,
  },
  { key: "phase", labelKey: "create.fields.phase", fieldType: "phase-select", entityTypes: CLIMATE_ACTION_AND_PROJECT },
  {
    key: "assignee",
    labelKey: "create.fields.assignee",
    fieldType: "user-select",
    entityTypes: CLIMATE_ACTION_AND_PROJECT,
  },
  {
    key: "focusArea",
    labelKey: "create.fields.focusArea",
    fieldType: "focus-area-select",
    entityTypes: CLIMATE_ACTION_AND_PROJECT,
  },
  {
    key: "labels",
    labelKey: "create.fields.labels",
    fieldType: "label-select",
    entityTypes: CLIMATE_ACTION_AND_PROJECT,
  },
  { key: "startDate", labelKey: "create.fields.startDate", fieldType: "date", entityTypes: CLIMATE_ACTION_AND_PROJECT },
  { key: "endDate", labelKey: "create.fields.endDate", fieldType: "date", entityTypes: CLIMATE_ACTION_AND_PROJECT },
  {
    key: "yearlyCosts",
    labelKey: "create.fields.yearlyCosts",
    fieldType: "number",
    entityTypes: CLIMATE_ACTION_AND_PROJECT,
  },
  {
    key: "reductionImpact",
    labelKey: "create.fields.reductionImpact",
    fieldType: "number",
    entityTypes: ["CLIMATE_ACTION"],
  },
  { key: "indicatorTitle", labelKey: "create.fields.indicatorTitle", fieldType: "text", entityTypes: ["INDICATOR"] },
  {
    key: "indicatorDescription",
    labelKey: "create.fields.indicatorDescription",
    fieldType: "richtext",
    entityTypes: ["INDICATOR"],
  },
  { key: "unit", labelKey: "create.fields.unit", fieldType: "unit-select", entityTypes: ["INDICATOR"] },
  { key: "frequency", labelKey: "create.fields.frequency", fieldType: "frequency-select", entityTypes: ["INDICATOR"] },
  { key: "values", labelKey: "create.fields.values", fieldType: "indicator-values", entityTypes: ["INDICATOR"] },
];

export function getAvailableFields(selectedEntityTypeList: EntityMode[]): DataRequestFieldDefinition[] {
  return DATA_REQUEST_FIELDS.filter(
    (field) =>
      !field.entityTypes ||
      field.entityTypes.length === 0 ||
      field.entityTypes.some((type) => selectedEntityTypeList.includes(type)),
  );
}
